// Colored pill for a support ticket's status. Green for resolved-type
// statuses, blue for in-progress ones, gray for anything else.
// Used by the tickets table and the ticket detail drawer.
const getStatusPillStyle = (status) => {
  // Soft tinted pills, same palette as the pills in the design reference
  const green = { background: "#E7F7EE", color: "#12945A" };
  const blue = { background: "#F3EAFE", color: "#7C3AED" };
  const gray = { background: "#F1F2F7", color: "#4B5266" };

  if (!status) return gray;

  const normalized = status.toLowerCase().replace(/[\s_-]/g, "");

  const greenStatuses = ["completed", "won'tdo", "won'tfix", "resolved", "cancelled", "canceled", "closed"];
  const blueStatuses = ["escalated", "waitingforcustomer", "waitingforsupport", "pending"];

  if (greenStatuses.includes(normalized)) return green;
  if (blueStatuses.includes(normalized)) return blue;
  return gray;
};

const TicketStatusPill = ({ status }) => (
  <span
    style={{
      ...getStatusPillStyle(status),
      borderRadius: "999px",
      padding: "0.25rem 0.75rem",
      fontSize: "0.75rem",
      fontWeight: 600,
      lineHeight: 1.4,
      textAlign: "center",
      maxWidth: "100%",
      display: "inline-block",
    }}
  >
    {status || "-"}
  </span>
);

export default TicketStatusPill;
